import { useMemo, useState } from "react";
import { BalanceGroup } from "hooks/user/useChartBalanceGroups";

export const useBalance = ({
  balanceGroups,
}: {
  balanceGroups: BalanceGroup[];
}) => {
  const [loop, setLoop] = useState(true);
  const [idle, setIdle] = useState({
    unconfortable: false,
    medium: false,
    average: false,
    perfect: false,
  });

  const totalBalance = useMemo<number>(() => {
    return balanceGroups?.reduce((a, b) => a + b.value, 0);
  }, [balanceGroups]);

  return {
    loop,
    setLoop,
    idle,
    setIdle,
    totalBalance,
  };
};
